import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

const readRoles = () => {
  try {
    const storedRoles = JSON.parse(sessionStorage.getItem('roles'));
    return Array.isArray(storedRoles) ? storedRoles : [];
  } catch {
    return [];
  }
};

// Protege uma rota por perfil de acesso. Sem token, devolve null e deixa o
// UserAuthentication redirecionar para o login; com token mas sem o perfil
// necessário, manda o usuário de volta para o início.
export default function RoleGuard({ allowedRoles, children }) {
  const token = sessionStorage.getItem('token');
  if (!token) return null;

  const roles = readRoles();
  const isAllowed = roles.some((role) => allowedRoles.includes(role));

  if (!isAllowed) return <Navigate to="/home" replace />;

  return children;
}

RoleGuard.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired,
};
